import { supabase } from '@/supabase';

export const useRoleStore = defineStore('roleStore', () => {
    const _isPending = ref<boolean>(false);
    const roles = ref<Array<any>>([]);
    const role = ref<any>({});

    const isPending = computed(() => { return _isPending.value });

    function $reset(): void {
        roles.value = [];
        role.value = {};
        _isPending.value = false;
    }

    async function fetchRoles(id: number = 0): Promise<string> {
        if (role.value.length > 1) return '';
        if (_isPending.value) return 'Error:  Please try again';
        _isPending.value = true;

        let msg = '';

        const { data, error } = await supabase
            .from('role')
            .select('*');

        if (error) {
            msg = error.message as string;
        }
        else if (data) {
            roles.value = data;
        }
        
        role.value = roles.value.find(l => l.id === id);

        if (!role.value) {
            role.value = {
                id: 0,
                name: ''
            }
        }

        _isPending.value = false;
        return msg;
    }

    return {
        roles,
        role,
        isPending,
        fetchRoles,
        $reset
    }
});

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useRoleStore, import.meta.hot))
}